import React from 'react';
import '../../../../styles/MoreAboutPlace.css';
import PropTypes from 'prop-types';

const MoreAboutPlace = ({ data, customClass = '' }) => {
  const { heading, description, imageList } = data;

  return (
    <div className={`rlPlaceDtl ${customClass ? customClass : ''}`}>
      <div className="wrapper">
        {heading && <h3>{heading}</h3>}
        <div className="rlPlaceDtl__content">
          <div className="rlPlaceDtl__left">{description && <p>{description}</p>}</div>
          <div className="rlPlaceDtl__right">
            {imageList && imageList.length > 0 && (
              <ul className="rlPlaceDtl__imglist">
                {imageList.map(({ id, imageUrl, altText }) => (
                  <li key={id} className="rlPlaceDtl__imglist--item">
                    <img loading="lazy" src={imageUrl} alt={altText} />
                  </li>
                ))}
              </ul>
            )}
            {/* <a className="rlPlaceDtl__viewall">View all photos</a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

MoreAboutPlace.propTypes = {
  data: PropTypes.object,
  customClass: PropTypes.string
};

export default MoreAboutPlace;
